import { render, staticRenderFns } from "./OnlyHeader.vue?vue&type=template&id=af693afe&scoped=true&"
import script from "./OnlyHeader.vue?vue&type=script&lang=js&"
export * from "./OnlyHeader.vue?vue&type=script&lang=js&"
import style0 from "./OnlyHeader.vue?vue&type=style&index=0&id=af693afe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af693afe",
  null
  
)

export default component.exports